import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { map } from 'rxjs';
import { AuthActions } from '../../components/auth/auth.actions';
import { ProdigyActions } from './prodigy.actions';

/**
 * @description Prodigy Effects.
 * @exports
 * @class ProdigyEffects
 */
@Injectable()
export class ProdigyEffects {
  private readonly actions = inject(Actions);

  readonly onSwitchProfile_Logout = createEffect(
    () => {
      return this.actions.pipe(
        ofType(AuthActions.switchProfile, AuthActions.logout),
        map(() => ProdigyActions.reset())
      );
    },
    { dispatch: true }
  );
}
